module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [(_vm.showgrid) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formEditavel) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.inserirAtividade()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Atividade")]) : _vm._e()])]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, [_c('div', {
    key: _vm.altera,
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: 'ATIVIDADES-' + _vm.atualizar,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' ? _vm._.union(_vm.table.items, _vm._.filter(_vm.propsPropostaBackup.atividades, function(a) {
        return _vm._.includes(_vm._.get(_vm.processoSolicitacao, 'exclusao', []), a.id)
      })) : _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "tbody-tr-class": _vm.modificacaoLinha,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "metas",
      fn: function(row) {
        return _vm._l((row.value), function(meta) {
          return _c('div', [_c('span', [_vm._v(_vm._s(meta.ds_descricao))])])
        })
      }
    }, {
      key: "ds_nome",
      fn: function(row) {
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "space-evenly",
            "align-items": "center"
          }
        }, [(('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO') ? _c('span', {
          staticClass: "pull-left"
        }, [(_vm.ehItemNovo(row.item)) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v("Novo")]) : _vm._e(), _vm._v(" "), (_vm.ehItemExcluido(row.item)) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Excluído")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('span', [_c('strong', [_vm._v(_vm._s(row.value))])]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_nome.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                      " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_nome.0')) + "\n                    ")]) : _vm._e()])])]
      }
    }, {
      key: "ds_documento_comprobatorio",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_documento_comprobatorio.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'ds_documento_comprobatorio.0', '0')) + "\n                  ")]) : _vm._e()])]
      }
    }, {
      key: "nr_periodo_inicial",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_inicial.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_inicial.0', '0')) + "\n                  ")]) : _vm._e()])]
      }
    }, {
      key: "nr_periodo_final",
      fn: function(row) {
        return [_c('div', {
          staticClass: "input-group",
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('span', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_final.0')) ? _c('span', {
          staticClass: "input-group-addon valorAlterado"
        }, [_vm._v("\n                    " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm.processoSolicitacao, 'alteracao', []), ['id', row.item.id]), 'nr_periodo_final.0', '0')) + "\n                  ")]) : _vm._e()])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm._.isNaN(row.item.percAtingimento) || row.item.percAtingimento < 1 || _vm._.includes(['CADASTRO', 'ANALISE', 'DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO', 'REVISAO'], _vm.propsProposta.ds_fase)) ? _c('div', [(_vm.ehItemExcluido(row.item)) ? _c('span', [_c('b-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          staticClass: "btn btn-warning btn-sm btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm._.remove(_vm.processoSolicitacao.exclusao, row.item.id);
              _vm.$forceUpdate()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Reincluir")])], 1) : _c('span', [(_vm.formEditavel) ? _c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm.formEditavel) ? _c('b-button', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.exclui(row); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>APAGAR</b> a atividade ' + row.item.ds_nome + ' ?'
            }),
            expression: "{ok: retorno => exclui(row), cancel: doNothing, message: 'Deseja <b>APAGAR</b> a atividade ' + row.item.ds_nome + ' ?'}"
          }],
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir\n                    ")]) : _vm._e()], 1)]) : _vm._e()]
      }
    }], null, false, 3707088559)
  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('meta')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "objective"
    }
  }, [_vm._v("Metas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "font-size": "4px"
    },
    attrs: {
      "options": _vm.propsMetas,
      "multiple": true,
      "placeholder": "Selecione um ou mais metas",
      "label": "ds_descricao",
      "track-by": "ds_descricao",
      "preselect-first": false,
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "selectedLabel": "",
      "name": "meta",
      "value": _vm.metaIndex
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }], null, false, 579952095),
    model: {
      value: (_vm.metaIndex),
      callback: function($$v) {
        _vm.metaIndex = $$v
      },
      expression: "metaIndex"
    }
  }, [_vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('meta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('meta')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome da atividade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome da atividade: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.ds_nome),
      expression: "atividadeForm.ds_nome"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome da atividade",
      "id": "proposal-activity-name",
      "title": '<h5>A atividade é uma ação que será realizada para atingir o objetivo acima</h5>',
      "placeholder": "Qual atividade será realizada para cumprir o objetivo acima",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.atividadeForm.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "ds_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome da atividade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da atividade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Documento comprobatório')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Documento comprobatório: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.ds_documento_comprobatorio),
      expression: "atividadeForm.ds_documento_comprobatorio"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Documento comprobatório",
      "type": "text",
      "maxlength": "255",
      "title": '<h5>Que tipo de documento será usado para comprovar a execução da atividade?</h5>',
      "placeholder": "Informe o tipo de documento que será usado para comprovar a execução da atividade"
    },
    domProps: {
      "value": (_vm.atividadeForm.ds_documento_comprobatorio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "ds_documento_comprobatorio", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Documento comprobatório')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Documento comprobatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "0 0 20px -20px !important"
    }
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Período de início')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Período da atividade: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', [_vm._v("\n              Início:\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.nr_periodo_inicial),
      expression: "atividadeForm.nr_periodo_inicial"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:' + _vm.terminoAtividade),
      expression: "'required|min_value:1|max_value:' + terminoAtividade"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "Período de início",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.atividadeForm.nr_periodo_inicial)
    },
    on: {
      "change": _vm.alteraPeriodo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "nr_periodo_inicial", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Período de início')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de início')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('Período de fim')
    }
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', [_vm._v("\n              Fim:\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.nr_periodo_final),
      expression: "atividadeForm.nr_periodo_final"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:' + _vm.inicioAtividade + '|max_value:' + _vm.periodoProjeto),
      expression: "'required|min_value:' + inicioAtividade + '|max_value:' + periodoProjeto"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "Período de fim",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.atividadeForm.nr_periodo_final)
    },
    on: {
      "change": _vm.alteraPeriodo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "nr_periodo_final", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Período de fim')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de fim')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(_vm.meta, _vm.atividadeForm)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b521a2be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/atividades.vue
// module id = 2057
// module chunks = 1